import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tu-van-vien/page.tsx");
